// emailConfig.js
const emailConfig = {
    serviceID: 'service_mmiqnsv',
    templateID: 'template_fllnyid',
    userID: 'DXeeExu84I6_CEQaj',
  };
  
  export default emailConfig;
  